import React from 'react'
import { ChevronDown, Contact, Star } from 'lucide-react'

import { SkeletonLoadingContacts } from 'src/features/SkeletonLoadingContacts'
import { ContactsTableSection } from 'src/features/ContactTableSection'
import Title from 'src/components/Title'

import { useTableForContactsHistory } from 'src/features/TableForContactsHistory/useTableForContactsHistory'
import { TableProps } from 'src/features/TableForContactsHistory/types'
import { Button } from 'src/components/shadcn/button'

const TableForContactsHistory = ({
  allContactsHistory,
  isLoadingGetContacts,
}: TableProps) => {
  const {
    locale,
    handleDelete,
    serviceTypeDictionary,
    editModeMap,
    toggleEditMode,
    handleFavorite,
    starredContacts,
    nonStarredContacts,
    titleNonStared,
    titleStarred,
    handleHideStarred,
    isStarredHide,
    handleHideContacts,
    isContactsHide,
  } = useTableForContactsHistory(allContactsHistory)

  return (
    <div className="space-y-4">
      {isLoadingGetContacts ? (
        <SkeletonLoadingContacts tableCount={2} />
      ) : !allContactsHistory.length ? (
        <Title
          title={locale.noResult}
          classes="text-xl text-center font-bold nmt-8"
        />
      ) : (
        <>
          {starredContacts.length > 0 && (
            <div>
              <Button
                variant="ghost"
                className="rounded-[10px] text-lg"
                onClick={handleHideStarred}
              >
                <Star />
                {titleStarred}
                <ChevronDown
                  className={`transition-transform duration-300 ${isStarredHide ? 'rotate-180' : ''}`}
                />
              </Button>

              {!isStarredHide && (
                <ContactsTableSection
                  contacts={starredContacts}
                  serviceTypeDictionary={serviceTypeDictionary}
                  editModeMap={editModeMap}
                  toggleEditMode={toggleEditMode}
                  handleFavorite={handleFavorite}
                  handleDelete={handleDelete}
                />
              )}
            </div>
          )}

          {nonStarredContacts.length > 0 && (
            <div>
              <Button
                variant="ghost"
                className="rounded-[10px] text-lg"
                onClick={handleHideContacts}
              >
                <Contact />
                {titleNonStared}
                <ChevronDown
                  className={`transition-transform duration-300 ${isContactsHide ? 'rotate-180' : ''}`}
                />
              </Button>
              {!isContactsHide && (
                <ContactsTableSection
                  contacts={nonStarredContacts}
                  serviceTypeDictionary={serviceTypeDictionary}
                  editModeMap={editModeMap}
                  toggleEditMode={toggleEditMode}
                  handleFavorite={handleFavorite}
                  handleDelete={handleDelete}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default TableForContactsHistory
